import { VStack } from '@chakra-ui/react';
import { useWatch } from 'react-hook-form';

import { Divider } from 'shared';

import { SessionSidebarFieldsetLabel } from 'features/sessions/components';
import {
  CoachSessionsDate,
  CoachSessionsTime,
  SessionsFormAttendanceNotes,
  SessionsTableFormDeleteButton,
} from 'features/sessions/components/Form/SessionInfo';
import { CoachSessionActions } from 'features/sessions/components/Form/SessionInfo/Actions';
import { SessionsActualTimeSelector } from 'features/sessions/components/Form/SessionInfo/ActualSessionTime';
import { SessionsFormNoShowCheckbox } from 'features/sessions/components/Form/SessionInfo/NoShowCheckbox';
import { SessionAttendanceStatusType } from 'features/sessions/config/types';

export const CoachSessionsInfo = () => {
  const [attendance, startAt, endAt]: [
    SessionAttendanceStatusType,
    string,
    string
  ] = useWatch({
    name: ['attendance', 'startAt', 'endAt'],
  });

  return (
    <VStack justifyContent="space-between" alignItems="flex-start" h="full">
      <VStack gap={3} alignItems="flex-start">
        <Divider />
        <SessionSidebarFieldsetLabel>Session info</SessionSidebarFieldsetLabel>
        <CoachSessionsDate sessionDate={startAt} attendance={attendance} />
        <CoachSessionsTime startTime={startAt} endTime={endAt} />
        <CoachSessionActions />
        <Divider />
        <SessionsFormNoShowCheckbox />
        <SessionsFormAttendanceNotes />
        <SessionsActualTimeSelector />
        <Divider />
      </VStack>
      <VStack p={0} pb={4} w="full">
        <SessionsTableFormDeleteButton />
      </VStack>
    </VStack>
  );
};
